import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { TtIcon, TtMenuItem, TtTrayActionCardField } from '@23/react'

import './ActionCardField.scss'

interface ActionCardFieldProps {
  name: string
  type: 'text-short' | 'text-long' | 'check'
  value: string
  isCurrentlyDragging: boolean
  onRemoveFieldClicked: (name: string) => void
  onAdditionalOptionChange: (event: CustomEvent, name: string) => void
}

const ActionCardField = ({
  name,
  type,
  value,
  isCurrentlyDragging,
  onRemoveFieldClicked,
  onAdditionalOptionChange,
}: ActionCardFieldProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: name,
  })

  const style = {
    transform: isCurrentlyDragging
      ? `translateY(${transform?.y ?? 0}px)`
      : null,
    transition,
    position: 'relative',
    zIndex: isDragging ? 1 : null,
  }

  return (
    <TtTrayActionCardField
      className={classnames('tray-action-card-field', {
        'is-dragging': isDragging,
      })}
      ref={setNodeRef}
      type={type}
      value={value}
      style={style}
      onTt-delete={() => {
        onRemoveFieldClicked(name)
      }}
      onTt-change={(e) => onAdditionalOptionChange(e, name)}
    >
      <TtIcon
        library="one"
        name="drag"
        slot="prefix"
        {...listeners}
        {...attributes}
      />
      <TtMenuItem value="text-short" slot="type-option">
        <TtIcon slot="prefix" library="one/webinars" name="text-short" />
        <FormattedMessage defaultMessage="Short text" />
      </TtMenuItem>
      <TtMenuItem value="text-long" slot="type-option">
        <TtIcon slot="prefix" library="one/webinars" name="text-long" />
        <FormattedMessage defaultMessage="Long text" />
      </TtMenuItem>
      <TtMenuItem value="check" slot="type-option">
        <TtIcon slot="prefix" library="one/webinars" name="check" />
        <FormattedMessage defaultMessage="Checkbox" />
      </TtMenuItem>
    </TtTrayActionCardField>
  )
}

export { ActionCardField }
